(() => {
  if (window.footerLocalization?.observe) {
    window.footerLocalization.observe();
    return;
  }

  const selectorId = 'etranslate-language-float-selector-theme2';
  const targetSelector = '[data-footer-language-selector]';
  const languageOptionSelector = '.etranslate-lo-select-dropdown-item[data-code]';
  const dropdownSelector = '.etranslate-language-list-dropdown-box';
  const openGroupClass = 'footer-group--language-open';
  const openSectionClass = 'footer-copyright--language-open';
  let moveScheduled = false;
  let observer;
  let dropdownObserver;
  let observedDropdown;
  let activeGroup;
  let activeSection;

  const clearLayering = () => {
    activeGroup?.classList.remove(openGroupClass);
    activeSection?.classList.remove(openSectionClass);
    activeGroup = null;
    activeSection = null;
  };

  const syncLayering = () => {
    const selector = document.getElementById(selectorId);
    const target = document.querySelector(targetSelector);
    const dropdown = selector?.querySelector(dropdownSelector);

    if (!target || !dropdown?.classList.contains('open')) {
      clearLayering();
      return;
    }

    const group = target.closest('.footer-group');
    const section = target.closest('.shopify-section');
    if (activeGroup !== group || activeSection !== section) clearLayering();

    activeGroup = group;
    activeSection = section;
    activeGroup?.classList.add(openGroupClass);
    activeSection?.classList.add(openSectionClass);
  };

  const observeDropdown = (selector) => {
    const dropdown = selector.querySelector(dropdownSelector);
    if (dropdown === observedDropdown) {
      syncLayering();
      return;
    }

    dropdownObserver?.disconnect();
    observedDropdown = dropdown;
    if (dropdown) {
      dropdownObserver = new MutationObserver(syncLayering);
      dropdownObserver.observe(dropdown, { attributes: true, attributeFilter: ['class'] });
    }
    syncLayering();
  };

  const moveSelector = () => {
    moveScheduled = false;

    const selector = document.getElementById(selectorId);
    const target = document.querySelector(targetSelector);
    if (!selector || !target) {
      clearLayering();
      return;
    }

    if (!selector.querySelector(languageOptionSelector)) {
      target.hidden = true;
      clearLayering();
      return;
    }

    if (selector.parentElement !== target) {
      target.appendChild(selector);
    }
    target.hidden = false;
    observeDropdown(selector);
  };

  const scheduleMove = () => {
    if (moveScheduled) return;
    moveScheduled = true;
    window.requestAnimationFrame(moveSelector);
  };

  const observeSelector = () => {
    observer?.disconnect();
    observer = new MutationObserver(scheduleMove);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    const currentObserver = observer;
    window.setTimeout(() => currentObserver.disconnect(), 60000);
    scheduleMove();
  };

  const releaseSelector = (event) => {
    const selector = document.getElementById(selectorId);
    if (selector && event.target.contains(selector)) {
      clearLayering();
      document.body.appendChild(selector);
    }
  };

  document.addEventListener('shopify:section:load', observeSelector);
  document.addEventListener('shopify:section:unload', releaseSelector);
  window.addEventListener('resize', scheduleMove);
  window.footerLocalization = { observe: observeSelector };
  observeSelector();
})();
